<hr style="margin-top: 0px; margin-bottom: 15px;">

<div class="container-fluid">
    <div style="text-align: left; display: flex; align-items: center; margin-bottom: 20px;">
        <label style="font-size: large; color:black; padding-right: 30px; margin-left: 10px; font-weight: 500;">ACTIVITY LOG </label>
        <label style="padding-right: 10px;">Select Date Range</label>
        <input type="text" class="daterangeinput" style="height: 32px;" autocomplete="off"
            ngxDaterangepickerMd
            [(ngModel)]="selectedDateRange"
            [showCustomRangeLabel]="true"
            [alwaysShowCalendars]="true"
            [ranges]="ranges"
            [showRangeLabelOnInput]="true"
            [linkedCalendars]="true"
            [isInvalidDate] = "isInvalidDate"
            [showClearButton]="true"
            (datesUpdated)="datesUpdated()"
            placeholder="Select Date Range"
            (rangeClicked)="setRangeSelected($event, 'Common')"
        />
    </div>

    <tabset>
    <tab heading="Messages and Mail ({{ alertMessagesDisplayed?.length || '0' }})" active="false">
        <p-table #alertTable [columns]="alertCols" [value]="alertMessagesDisplayed" sortField="createdDate" sortOrder="-1" [scrollable]="true" scrollHeight="55vh">

            <ng-template pTemplate="header" let-columns>
                <tr style="height: 40px;">
                    <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr *ngIf="!rowData.hidden">
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.createdDate | date : 'medium' }}
                    </td>

                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.appComponentName }}
                    </td>

                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.actionType=='Email'" style="color:#548235"> {{rowData.actionType}} </div>
                        <div *ngIf="rowData.actionType=='Message'" style="color:#5279bc"> {{rowData.actionType}} </div>
                    </td>

                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.appComponentItem }}
                    </td>

                    <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                        <div style="white-space: pre-wrap;">{{rowData.details}}</div>
                    </td>

                    <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.count }}
                    </td>

                    <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                        <div (click)="acknowledgeAlert(rowData)" style="cursor: pointer; color:#1c4966">
                            {{ rowData.acknowledged ? 'Yes' : 'No' }}
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns.length">
                        Select date range
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="caption" let-rowData>
                <div style="text-align: left;">
                    <label style="margin-right: 15px; margin-left: 0px; ">Types:</label>
                    <input type="checkbox" style="vertical-align: middle" [(ngModel)]="alertMsgTypesSelected[0]" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px; color:#5279bc">Messages</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="alertMsgTypesSelected[1]" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px; color:#548235">Emails</label>

                    <span style="float: right;">
                        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                        <input type="text" pInputText size="30" placeholder="Search Table"
                            (input)="alertTable.filterGlobal($event.target.value, 'contains')"
                            style="width:auto; height: 25px">
                    </span>
                </div>

                <div style="margin-top: 5px;">
                    <label style="margin-right: 15px; margin-left: 0px;">Tabs:</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="alertAppFuncsSelected[0]" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Dashboard</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="alertAppFuncsSelected[1]" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Sensors</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="alertAppFuncsSelected[2]" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">User Groups</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="alertAppFuncsSelected[3]" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Gateways</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="alertAppFuncsSelected[4]" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Sensor Groups</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="alertAppFuncsSelected[5]" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Events-Actions</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="alertAppFuncsSelected[6]" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Charts</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="alertAppFuncsSelected[7]" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Imports</label>
                    <label style="margin-right: 15px; margin-left: 4px; float: right">Include Acknowledged</label>
                    <input type="checkbox" style="vertical-align: middle; float: right; margin-top: 4px" [(ngModel)]="alertShowAcknowleged" (ngModelChange)="alertFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                </div>

            </ng-template>

        </p-table>
    </tab>

    <tab heading="Changes ({{ auditMessagesDisplayed?.length || '0' }})" active="true">
        <p-table #auditTable [columns]="auditCols" [value]="auditMessagesDisplayed" sortField="createdDate" sortOrder="-1" [scrollable]="true" scrollHeight="55vh">
            <ng-template pTemplate="header" let-columns>
                <tr style="height: 40px;" >
                    <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                        {{col.header}}
                        <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.createdDate | date : 'medium' }}
                    </td>
                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.userName }}
                    </td>
                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.appComponentName }}
                    </td>
                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.actionType=='New'" style="color:#548235"> {{rowData.actionType}} </div>
                        <div *ngIf="rowData.actionType=='Edited'" style="color:#5279bc"> {{rowData.actionType}} </div>
                        <div *ngIf="rowData.actionType=='Deleted'" style="color:#c8102e"> {{rowData.actionType}} </div>
                    </td>
                    <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.appComponentItem }}
                    </td>
                    <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.details }}
                    </td>
                    <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.userNotes }}
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns.length">
                        Select date range
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="caption" let-rowData>
                <div style="text-align: left;">
                    <label style="margin-right: 15px; margin-left: 0px">Types:</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditMsgTypesSelected[0]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px; color:#548235">New</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditMsgTypesSelected[1]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px; color:#5279bc">Edited</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditMsgTypesSelected[2]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px; color:#c8102e">Deleted</label>

                    <span style="float: right;">
                        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                        <input type="text" pInputText size="30" placeholder="Search Table"
                            (input)="auditTable.filterGlobal($event.target.value, 'contains')"
                            style="width:auto; height: 25px">
                    </span>
                </div>

                <div style="margin-top: 5px;">
                    <label style="margin-right: 15px; margin-left: 0px">Tabs:</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditAppFuncsSelected[0]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Dashboard</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditAppFuncsSelected[1]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Sensors</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditAppFuncsSelected[7]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Users</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditAppFuncsSelected[2]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">User Groups</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditAppFuncsSelected[3]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Gateways</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditAppFuncsSelected[4]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Sensor Groups</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditAppFuncsSelected[5]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Events-Actions</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditAppFuncsSelected[6]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Charts</label>
                    <input type="checkbox" style="vertical-align: middle;" [(ngModel)]="auditAppFuncsSelected[8]" (ngModelChange)="auditFilterChanged()" [ngModelOptions]="{standalone: true}"/>
                    <label style="margin-right: 15px; margin-left: 4px">Imports</label>
                </div>

            </ng-template>

        </p-table>
    </tab>
    </tabset>
</div>


<ng-template #loading>
    <div class="col-xs-4 col-lg-3">
    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    <span>Loading...</span>
    </div>
</ng-template>

